"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.editWebsiteLogo = exports.editEmailConfiguration = exports.SSO_KNOWLEDGE_BASE_DOCUMENT = exports.SSO_SAML_AUDIENCE_ENDPOINT = exports.SSO_SAML_ACS_ENDPOINT = void 0;

var _enviro = _interopRequireDefault(require("enviro"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var isQa = _enviro.default.isQa('settings-ui');

var API_ORIGIN = "https://api.hubspot" + (isQa ? 'qa' : '') + ".com";

var PORTAL_ID = _hubspot.default.get();

var ROOT_PATH = "https://app.hubspot" + (isQa ? 'qa' : '') + ".com";
var SSO_SAML_ACS_ENDPOINT = API_ORIGIN + "/login-api/v1/saml/acs";
exports.SSO_SAML_ACS_ENDPOINT = SSO_SAML_ACS_ENDPOINT;
var SSO_SAML_AUDIENCE_ENDPOINT = API_ORIGIN + "/login-api/v1/saml/login";
exports.SSO_SAML_AUDIENCE_ENDPOINT = SSO_SAML_AUDIENCE_ENDPOINT;
var SSO_KNOWLEDGE_BASE_DOCUMENT = 'https://knowledge.hubspot.com/articles/kcs_article/account/can-i-use-single-sign-on-sso-with-hubspot';
exports.SSO_KNOWLEDGE_BASE_DOCUMENT = SSO_KNOWLEDGE_BASE_DOCUMENT;

var editEmailConfiguration = function editEmailConfiguration() {
  return ROOT_PATH + "/settings/" + PORTAL_ID + "/marketing/email/configuration";
};

exports.editEmailConfiguration = editEmailConfiguration;

var editWebsiteLogo = function editWebsiteLogo() {
  return ROOT_PATH + "/settings/" + PORTAL_ID + "/website/pages/all-domains/branding";
};

exports.editWebsiteLogo = editWebsiteLogo;